import { ApplicationType } from "../enums";

let applicationType: ApplicationType = ApplicationType.Unset;

export const setApplicationType = (type: ApplicationType): void => {
  applicationType = type;
};

export const getApplicationType = (): ApplicationType => {
  return applicationType;
};

interface IApplications {
  isMainApp: boolean;
  isAdminApp: boolean;
  isLandingsApp: boolean;
}

export const getApplicationsByType = (type: ApplicationType): IApplications => {
  return {
    isMainApp: type === ApplicationType.Main,
    isAdminApp: type === ApplicationType.Admin,
    isLandingsApp: type === ApplicationType.Landings,
  };
};

export const isMainApp = (): boolean => {
  return applicationType === ApplicationType.Main;
};

export const isAdminApp = (): boolean => {
  return applicationType === ApplicationType.Admin;
};

export const isLandingsApp = (): boolean => {
  return applicationType === ApplicationType.Landings;
};
